import React from 'react';
import { FieldDiamond } from './FieldDiamond';
import { volumes } from '../data/volumes';
export function Tomes() {
  return <section aria-labelledby="tomes-heading" className="w-full bg-ice" data-id="element-303" data-mp="1ysa6yqqm73g9">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-304" data-mp="1tzh3052yzz58">
        <div className="text-center" data-id="element-305" data-mp="1txw9mise6m8y">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-306" data-mp="1p1xod42d1kcr">
            The complete season
          </p>
          <h2 id="tomes-heading" className="chalk-underline mt-3 font-display font-bold uppercase text-ink text-4xl sm:text-5xl" data-id="element-307" data-mp="1l0voqm4j76a9">
            Inside the pack — six volumes
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-308" data-mp="1b37r9ofjjkoe">
            One season arc: learn to run the practice, build each skill, turn
            it into team defense, then handle game day. Each volume stands on
            its own.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-309" data-mp="30h46wbissyuk">
          {volumes.map(tome => <article key={tome.number} className="clip-corner flex flex-col overflow-hidden rounded-2xl border border-ice-dark bg-white shadow-card" data-id="element-310" data-mp="27j05wo38zka5">
              <div className={`relative overflow-hidden ${tome.badge}`} data-id="element-311" data-mp="1xkkesl480b0n">
                <FieldDiamond className="pointer-events-none absolute -right-5 -top-6 h-24 w-24 text-white/15" data-id="element-312" data-mp="22iltktum5o6b" />
                <div className="relative flex items-center justify-between px-5 py-3.5" data-id="element-313" data-mp="2q7wymnizy4q9">
                  <span className="font-display text-xs uppercase tracking-[2px] text-white/85" data-id="element-314" data-mp="2v56no22h4edk">
                    Volume {tome.number}
                  </span>
                  <span className="font-display text-4xl leading-none text-white" data-id="element-315" data-mp="2lg6j8357cqrz">
                    {tome.number}
                  </span>
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6 pt-5" data-id="element-316" data-mp="3dwzepqxzfpin">
                <h3 className="font-display text-2xl leading-tight text-ink" data-id="element-317" data-mp="3dyahbnfoyr86">
                  {tome.title}
                </h3>
                <p className="mt-2 text-sm text-ink-soft" data-id="element-318" data-mp="3itvd5lppx5z1">{tome.promise}</p>
                <ul className="mt-4 grid gap-2 border-t border-ice-dark pt-4" data-id="element-319" data-mp="3iuoe261zx199">
                  {tome.contents.map(item => <li key={item} className="flex gap-2.5 text-[13px] text-ink" data-id="element-320" data-mp="39tgpifpa7esd">
                      <span className="mt-[5px] h-2.5 w-2.5 flex-none rounded-full bg-gold ring-1 ring-clay/40" data-id="element-321" data-mp="39vjbmonbcnrt" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}